import { useTranslation } from 'react-i18next'

export default function useApplyV2NavTranslations() {
    const { t } = useTranslation()

    const navTranslations: Record<string, string> = {
        profile: t('4647', 'Profile'),
        cv: t('4836', 'Upload CV'),
        questions: t('5655', 'Questions'),
        education: t('78', 'Education'),
        languages: t('3296', 'Languages'),
        license: t('10188', 'License'),
        skills: t('76', 'Skills'),
        reviewApply: t('10189', 'Review & Apply'),
        course: t('10309', 'Courses'),
        driverLicence: t('10191', 'Driver Licence'),
        language: t('95', 'Language'),
        reference: t('1208', 'References'),
        skill: t('76', 'Skills'),
        workExperience: t('80', 'Work Experience'),
        question: t('5655', 'Questions'),
    }

    const getTitle = (key: string, fallback = key): string => {
        return navTranslations[key] ?? t(key, fallback)
    }

    return {
        navTranslations,
        getTitle,
    }
}
